export default "__VITE_ASSET__CMEphrXc__"